import React from "react"
import RyderLivescoringMatchCardDefaultView from "@/components/RyderLivescoring/views/default/RyderLivescoringMatchCardDefaultView"
import RyderLivescoringMatchCardNin9rsView from "@/components/RyderLivescoring/views/nin9rs/RyderLivescoringMatchCardNin9rsView"

const RyderLivescoringMatchCard = ({
    match = {},
    teamColors = {},
    leftTeamId,
    rightTeamId,
    colors,
    customDesign,
}) => {
    // We create a map of sides by teamId
    const sideMap = Object.values(match.sides || {}).reduce((acc, side) => {
        acc[side.teamId] = side
        return acc
    }, {})

    // We remove each side (or {} if it does not exist)
    const leftSide = sideMap[leftTeamId] || {}
    const rightSide = sideMap[rightTeamId] || {}

    // We normalize the list of players
    const norm = (s) =>
        s.players
            ? Array.isArray(s.players)
                ? s.players
                : [s.players]
            : []

    const leftPlayers = norm(leftSide)
    const rightPlayers = norm(rightSide)

    // Win/Draw States
    const leftWon = leftSide.is_winner === true
    const rightWon = rightSide.is_winner === true
    const isDraw = Boolean(match.result) && !leftWon && !rightWon

    // Fallback “TBD” for each side
    const tbdLeft = !leftSide.teamId
    const tbdRight = !rightSide.teamId

    // Here is the logic of holes
    const holes = match.resultsByHole
        ? Object.entries(match.resultsByHole)
        : Array(18).fill(null)


    // We make sure to pass the IDs as numbers
    const leftIdNum = Number(leftTeamId)
    const rightIdNum = Number(rightTeamId)

    const matchDate = match.date
        ? new Date(match.date.date).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
        })
        : ""

    const matchHour = match.hour
        ? new Date(match.hour.date).toLocaleString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        })
        : ""

    if ("nin9rs" === customDesign) {
        return <RyderLivescoringMatchCardNin9rsView
            leftWon={leftWon}
            rightWon={rightWon}
            matchDate={matchDate}
            matchHour={matchHour}
            leftPlayers={leftPlayers}
            leftIdNum={leftIdNum}
            tbdLeft={tbdLeft}
            leftSide={leftSide}
            rightPlayers={rightPlayers}
            rightIdNum={rightIdNum}
            tbdRight={tbdRight}
            rightSide={rightSide}
            colors={colors}
            customDesign={customDesign}
            match={match}
            isDraw={isDraw}
            holes={holes}
            teamColors={teamColors}
        />
    } else {
        return <RyderLivescoringMatchCardDefaultView
            leftWon={leftWon}
            rightWon={rightWon}
            matchDate={matchDate}
            matchHour={matchHour}
            leftPlayers={leftPlayers}
            leftIdNum={leftIdNum}
            tbdLeft={tbdLeft}
            leftSide={leftSide}
            rightPlayers={rightPlayers}
            rightIdNum={rightIdNum}
            tbdRight={tbdRight}
            rightSide={rightSide}
            colors={colors}
            customDesign={customDesign}
            match={match}
            isDraw={isDraw}
            holes={holes}
            teamColors={teamColors}
        />
    }
}

export default RyderLivescoringMatchCard
